<template>
  <base-button type="submit" class="btn-primary" text="登録" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'RegisterButton',
  components: {
    BaseButton,
  },
}
</script>
